module.exports = __webpack_public_path__ + "static/media/profileDark.690af416.svg";